import React from 'react'
import { Switch } from 'react-router-dom'
import qs from 'query-string'
import Route from '../../components/boundary-route'
import {
  getCategorySlugFromPath,
  trimSlashes,
  getFilterStateFromPath,
  buildUrlFromFilterState,
} from './helpers'
import Shell from './shell'
import Home from './home'
import ProductDetail from './product-detail'
import ProductsContents from './products'

const Products = props => (
  <Shell {...props}>
    <Switch>
      <Route
        path={'/products/:type(retailer|brand)/:slug'}
        render={routeProps => {
          const filterParam =
            routeProps.match.params.type === 'retailer' ? 'store' : 'brand'
          return (
            <ProductsContents
              hideCategoryInformation
              filterState={{
                categorySlug: 'products',
                categoryPath: 'products',
                [filterParam]: routeProps.match.params.slug,
                prefix: routeProps.match.url.substring(1), // Remove the leading '/'
                ...getFilterStateFromPath(routeProps),
              }}
              buildUrl={buildUrlFromFilterState}
              categorySlug="products"
              subcategoryDepth={2}
              {...routeProps}
            />
          )
        }}
      />
      <Route
        strict
        path={`/products/:retailer/:title/:id(\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12})`}
        render={routeProps => <ProductDetail {...routeProps} />}
      />
      <Route
        path={`/products/:category/:subCategory1?/:subCategory2?`}
        render={routeProps => (
          <ProductsContents
            brand
            filterState={{
              categorySlug: getCategorySlugFromPath(routeProps.match),
              categoryPath: trimSlashes(routeProps.match.url),
              ...getFilterStateFromPath(routeProps),
            }}
            buildUrl={filterState => buildUrlFromFilterState(filterState)}
            categorySlug={getCategorySlugFromPath(routeProps.match)}
            subcategoryDepth={1}
            {...routeProps}
          />
        )}
      />
      <Route
        path="/products"
        render={routeProps => {
          const queryParams = qs.parse(routeProps.location.search)
          if (queryParams.search_query) {
            return (
              <ProductsContents
                brand
                filterState={{
                  categorySlug: getCategorySlugFromPath(routeProps.match),
                  categoryPath: routeProps.match.url.substring(1),
                  ...getFilterStateFromPath(routeProps),
                }}
                buildUrl={filterState => buildUrlFromFilterState(filterState)}
                categorySlug={getCategorySlugFromPath(routeProps.match)}
                subcategoryDepth={2}
                {...routeProps}
              />
            )
          } else {
            return <Home {...routeProps} />
          }
        }}
      />
    </Switch>
  </Shell>
)

export default Products
